import { ROUTE } from '@lib/core/const';
import { PERMISSION } from '@lib/core/enum';
import { RoutingTabItem } from '@proget-shared/routing';

export const TABS: RoutingTabItem[] = [
  {
    title: 'library.user_card.tab.devices',
    route: [ROUTE.USER.TAB.DEVICES],
    permission: PERMISSION.USER_CARD_ALLOW_VIEW,
  },
  {
    title: 'library.user_card.tab.attributes',
    route: [ROUTE.USER.TAB.ATTRIBUTES],
    permission: PERMISSION.USER_CARD_ALLOW_VIEW,
  },
  {
    title: 'library.user_card.tab.certificates',
    route: [ROUTE.USER.TAB.CERTIFICATES],
    permission: PERMISSION.USER_CARD_ALLOW_VIEW,
  },
  {
    title: 'library.user_card.tab.audit_logs',
    route: [ROUTE.USER.TAB.AUDIT_LOGS],
    permission: PERMISSION.ALLOW_DISPLAY_AUDIT_LOGS,
  },
  {
    title: 'library.user_card.tab.backups',
    route: [ROUTE.USER.TAB.BACKUPS],
    permission: PERMISSION.USER_CARD_ALLOW_VIEW,
  },
  {
    title: 'library.user_card.tab.settings',
    route: [ROUTE.USER.TAB.SETTINGS],
    permission: PERMISSION.USER_CARD_ALLOW_VIEW,
  },
  {
    title: 'graph.title',
    route: [ROUTE.USER.TAB.GRAPH],
    permission: PERMISSION.SUPER_ADMIN,
  },
];
